import { useState } from "react";
import { Link } from "react-router-dom";

//import tags
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

// import resources
import sliderVideo from '../../assets/image/slide.mp4';

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";


function Slider({locale}) {

    //get locale
    const { t } = useTranslation();

    const [search, setSearch] = useState('');

    return (
        <section className="sliderSection">
            <video autoPlay muted loop>
                <source src={sliderVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="SliderContent">
                <div className="SliderText">
                    <h1>{t('slider_text1')}</h1>
                    <pre>{t('slider_text2')}</pre>
                </div>
                <div className="sliderSearch">
                    <div className="sliderSearchInput">
                        <input className="mainSearch" name="key" value={search} onChange={(e) => setSearch(e.target.value)} type="text" placeholder={t('search_placeholder')} />
                        <Link to={`/${locale}/property?key=${search}`} className="searchButton"><FontAwesomeIcon icon={faMagnifyingGlass} /></Link>
                    </div>
                </div>
            </div>
        </section>
    )
    
}

export default Slider;